import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // Check if user is authenticated by looking for token, username, and role in localStorage
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  // If user is authenticated, render the protected component
  if (token && username && role) {
    return children;
  }

  // If not authenticated, redirect to login
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
